import styled from 'styled-components'

import Button from '../Button/Button'

const Toggle = styled(Button).attrs(props => ({
  type: 'gray600',
  outline: true,
  ...props,
}))`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &::after {
    content: ' ';
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top-width: 5px;
    border-top-style: solid;
    margin-left: ${props => (props.theme.gutter * 1) / 3}px;
  }
`

export default Toggle
